import {
    BodyText, PageBlock, HeaderBox, HeaderTitle, PrimaryButton, SecondaryText,
} from "../../features/Atoms";
import { Grid } from "@material-ui/core"
import Layout from "../Layout";
import staff from "./../../images/staff.PNG"
import indexImg from "./../../images/Indexbackground.jpg";



export default function TermsConditionPage(props) {

    return (
        <Layout className="detailsBlock">
            <HeaderBox coverPic={indexImg} style={{ paddingTop: '35%', }} >
                <HeaderTitle className="marginGapBottom">
                    Terms and Conditions
                </HeaderTitle>
            </HeaderBox>
            <PageBlock className="highlight" style={{ textAlign: 'left' }}>
                <Grid item xs={12}>
                    <BodyText>
                        <br />
                        <SecondaryText>CyberTeck Academy Online</SecondaryText>
                        <br /><br />
                        These additional Terms and Conditions are intended to keep students safe
                        and make CyberTeck Academy (CTA) Online programs positive and productive.
                        By purchasing, using, or allowing your student to use any of CyberTeck
                        Academy’s Online programs, you agree that you and your student will abide
                        and be bound by these Terms and Conditions as well as CyberTeck Academy’s
                        General Terms and Conditions found <a href="https://docs.google.com/document/d/1SNdHDJVS-DYnZji_c0f1DxfIhpfZsmaYVZL3Rd1tLEg/edit">
                            HERE</a>. In cases where these Terms and
                        Conditions and CyberTeck Academy’s General Terms and Conditions conflict,
                        the terms found herein apply to any CyberTeck Academy’s Online Program or
                        Product.<br /><br />
                        <b>I. Online Private Lessions(OPL)</b><br /><br />
                        <b>A. General Infomation</b><br />
                        <ol>
                            <li>Multi-lesson packs are intended to be used in full, and unused lessons
                                will not be refunded.
                            </li>
                            <li>
                                Subscriptions shall renew each month on the date indicated at the
                                time of purchase. You agree that CyberTeck Academy has a right to
                                auto charge your credit card on file for the amount indicated on
                                the date indicated during the purchase flow. Upon successful
                                payment, you will be provided a new set of lessons equal to the
                                initial subscription amount purchased. Subscriptions may be
                                canceled online in your account at any time before midnight PT the
                                day prior to the renewal date, or by calling our customer service&nbsp;
                                <a title="mailto:info@cyberteckacademy.com" href="mailto:info@cyberteckacademy.com" target="" 
                                rel="noopener noreferrer nofollow">info@cyberteckacademy.com</a>&nbsp;
                                department before 3pm PT the business day prior to your renewal
                                date. Cancellations not made by these times will be considered
                                cancellations of the next subscription renewal cycle. Once a
                                subscription renews, you can schedule your new lessons immediately,
                                and refunds cannot be provided. Subscriptions cannot be prorated, and
                                unused courses purchased as part of a subscription are not refundable.
                            </li>
                            <li>
                                All lessons must be scheduled within one year of purchase. Lessons expire
                                a year from purchase, with no refund.
                            </li>
                            <li>
                                Fees for Online Private Lessons are non-refundable and non-transferrable. Lessons not
                                used by the expiration date are forfeited and cannot be refunded in full or prorated.
                            </li>
                            <li>
                                Lessons can be rescheduled for any reason up to 24 hours prior to the
                                scheduled lesson through your My Account. If your student fails to
                                attend a scheduled lesson, the lesson will be deducted from your
                                available sessions. No changes can be made within 24 hours of the
                                lesson start time. A post-lesson progress report will be sent to your
                                email address on file upon completion of each lesson.
                            </li>
                            <li>
                                Lessons are only available for subjects set out by CyberTeck Academy.
                            </li>
                            <li>Lessons will only be taught in English.</li>
                            <li>For safety and security reasons,CyberTeck Academy will video record every
                                lesson. Parents and guardians may request to have a video deleted by sending
                                an email request to info@cyberteckacademy.com. If there are multiple students
                                in the lesson from different families, we must retain the video to protect the
                                privacy of the students. Except when legally required, we are not able to
                                provide copies of videos.
                            </li>
                            <li>Generally, only one student per lesson is allowed. However, CyberTeck
                                Academy reserves the right to allow parents to share their lesson link with
                                one other student. All students that participate in the lesson are bound by
                                these Terms and Conditions including our code of conduct.
                            </li>
                            <li>CyberTeck Academy has the right to refuse service.</li>
                            <li>Lessons are a guidance/tutoring service only. No specific outcomes are
                                promised or guaranteed. iD Tech is not responsible for any specific
                                outcome or lack thereof.
                            </li>
                        </ol><br /><br />
                        <b>B.  Scheduling/Rescheduling Online Private Lessons</b><br />
                        <ol>
                            <li>You are responsible for scheduling all lessons via your My Account or
                                by contacting 1-888-709-8324.</li>
                            <li>You can reschedule a lesson through your My Account. All rescheduling
                                must be done with more than 24 hours notice. If sufficient notice is not
                                provided, then the session is treated as a no show, and the lesson will be
                                deducted from your lesson balance.
                            </li>
                        </ol><br />
                        <b>II.  Small-Group Classes</b>
                        <ol>
                            <li>Missed classes will be forfeited and cannot be made up or refunded.</li>
                            <li>Fees for Small-Group Classes are non-refundable and non-transferrable.</li>
                            <li>Only students registered for the class may participate.</li>
                            <li>Classes are only available for subjects set out by CyberTeck Academy.</li>
                            <li>Classes will only be taught in English.</li>
                            <li>For safety and security reasons, CyberTeck Academy will video record every
                                class. Copies of the recording cannot be provided to protect the privacy of
                                the students in the course. Questions should be addressed to
                                info@cyberteckacademy.com</li>
                            <li>CyberTeck Academy has the right to refuse service.</li>
                            <li>Small-Group Classes are a guidance/tutoring service only. No specific
                                outcomes are promised or guaranteed. CyberTeck Academy is not responsible for
                                any specific outcome or lack thereof.</li>
                            <li>At the time of purchase, you may have the option to pay the fee for a
                                Small-Group Class in full or split the course tuition into payments. If you
                                select to make payments, payments will be due as set out during checkout and
                                as listed in your My Account. Note: If you have students in Small-Group Classes
                                on different days, payments will be collected separately as payment due dates are
                                based on the start day of the class. By selecting the payment option, you are
                                authorizing CyberTeck Academy to auto-charge your card on file for the amounts due
                                per your payment schedule. If for any reason a payment is not made by the due date,
                                you will have 5 business days from the due date to bring the account current, or
                                your student will be removed from the course until the account is brought current,
                                and you may be charged a $25 late fee. No refunds, credits, or make-up classes will
                                be provided if a session is missed due to a delinquent payment.
                            </li>
                            <li>Changes to a class start date, subject, or time can be made either through your
                                My Account, or by calling Customer Service at least 72 hours prior to the
                                start date of the class. Changes cannot be made less than 72 hours prior to the
                                start of a class or once the class has started. If you purchase a Semester
                                product longer than 12 weeks, you are able to make changes as set out in Section
                                I for each 12-week block.
                            </li>
                        </ol><br /><br /><br />
                    </BodyText>
                </Grid>
            </PageBlock>
        </Layout>
    );
}